import Layout from "../components/utils/layout";
import React from "react";

const AbroadPayments = () => {
    const screenId="AbroadPayments"
    const charts = {
        abroad_payments_non_existent_token: {
            source:"redshift"
        },
        potential_overseas_fraud_attack: {
            source:"redshift"
        },
        other_trx_with_unknown_cards: {
            source:"redshift"
        }
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default AbroadPayments
